module.exports = __webpack_public_path__ + "static/media/downloadIcon.5de3a936.svg";